export const routes = [
  {
    name: 'root',
    path: '/',
    component: () => import(/* webpackChunkName: "root" */'@pages/Home.vue'),
    meta: {
      navColors: {
        navText: "white-green",
        navOptions: "deep-grey-green"
      }
    }
  }
]